<template>
    <section id="default-page" class="notifications-page">
        <div class="container full-width">
            <div class="row">
                <div class="search-result-top">
                    <div class="top">
                        <div class="left">
                            <h2>{{title}}</h2>
                        </div>
                        <div class="right">
                            <button v-if="unreadCount" class="btn btn-default" @click="markAllRead">
                                Mark All Read
                            </button>
                        </div>
                    </div>
                    <template v-for="notification in notifications">
                        <div v-if="notification.data.title" :class="notificationClass(notification)">
                            <div class="read-icon">
                                <i v-if="notification.read_at" class="fa fa-envelope-open-o" aria-hidden="true"></i>
                                <i v-else @click="markRead([notification.id])" title="click to mark as read" class="fa fa-envelope-o cursor-pointer" aria-hidden="true"></i>
                            </div>
                            <a v-if="notification.data.route" :href="notification.data.route" class="notification-grid">
                                <div>
                                    {{displayDate(notification.created_at)}}
                                </div>
                                <div>
                                    {{notification.data.title}}
                                </div>
                                <div>
                                    {{notification.data.message}}
                                </div>
                            </a>
                            <template v-else>
                                {{displayDate(notification.created_at)}} - {{notification.data.title}} - {{notification.data.message}}
                            </template>
                        </div>
                    </template>
                    <div v-if="!notifications || notifications.length === 0">
                        You have no notifications
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapActions, mapState } from 'vuex'
    import moment from 'moment'
    export default {
        props: ['type'],
        async mounted(){
            await this.getNotifications()
            this.addToHistoryStack();
            this.check = moment().subtract(5, 'days');
        },
        computed:{
            notifications(){
                let getter = this.$store.getters[`notifications/${this.type}`];
                return getter;
            },
            unreadCount(){
                let getter = this.$store.getters[`notifications/unread_${this.type}_count`];
                return getter;
            },
            title(){
                if (this.type === 'bids') {
                    return 'Bid notifications'
                } else {
                    return 'Bid message notifications'
                }
            }
        },
        methods: {
            ...mapActions({
                getNotifications: 'notifications/getNotifications',
                markRead: 'notifications/markRead',
                addToNextPrevStack: 'auction_nextprev/addToStack',

            }),
            displayDate(date){
                let mdate = moment(date)
                if (mdate.isAfter(this.check)) {
                    if(window.innerWidth < 500) {
                        return mdate.format('ddd HH:mm')
                    } else {
                        return mdate.format('dddd HH:mm')
                    }
                } else {
                    return mdate.format(this.defaultMomentDateFormat() + ' dddd HH:mm')
                }
            },
            notificationClass(notification) {
                let classes = ['notification'];
                if (notification.read_at) {
                    classes.push('is-read')
                }
                return classes.join(' ')
            },
            addToHistoryStack(){
                if (this.notifications && this.notifications.length) {
                    const ids = [];
                    this.notifications.forEach(note => {
                        if (note.data && note.data.userBid && note.data.userBid.vehicle && note.data.userBid.vehicle.api_id) {
                            ids.push(note.data.userBid.vehicle.api_id)
                        } else if (note.data && note.data.bidMessage && note.data.bidMessage.bid && note.data.bidMessage.bid.vehicle) {
                            ids.push(note.data.bidMessage.bid.vehicle.api_id)
                        }
                    })
                    if (ids.length) {
                        this.addToNextPrevStack({ids})
                    }
                }
            },
            markAllRead(){
                if (this.notifications && this.notifications.length) {
                    const ids = [];
                    this.notifications.forEach(note => {
                        if (!note.read_at) {
                            ids.push(note.id)
                        }
                    })
                    if (ids.length) {
                        this.markRead(ids)
                    }
                }
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/NotificationsPage.vue